import { ElMessage, ElMessageBox,ElNotification } from "element-plus";
import Loading from "../../../utils/Loading"; //获取加载组件
import { WebsiteUrl } from "../../../utils";

import Api_Member from "../../../api/FrontEnd/Member";

export default {
	name: 'ModuleBox',
	components: {

	},
	props:{
		onShow:{
			type:Boolean,
			default:false,
		},
		onData:{
			type:Object,
			default:null
		}
	},
	data(){
		return{
			ValueData:'111',

			Visible:false,

			Title:"",
			ExchangeData:[],

			IntroduceBackgroundElementUrl:WebsiteUrl()+'/images/ModuleBoxIntroduceBackgroundElement1.png',
		}
	},
	methods:{
		onHide(){
			this.$emit("onHide",false);
			this.Visible = false;
		},
		//初始化接口
		GetInit(){
			this.InfoData = [];
			Loading.LoadingShow();
			let RequestData = {};
			let ReturnData = Api_Member.GetExchangePopover(RequestData);
			ReturnData.then(response => {
				// console.log(response);
				Loading.LoadingHide();
				let State = response['Data'][0].State;
				let Message = response['Data'][0].Message;
				if(State == 'Success'){
					let Data = JSON.parse(response['Data'][0].Data);
					// console.log(Data.ExchangeData);
					// console.log("Init...");

				
					this.Visible = true;
					this.Form = {};
					this.Title = "积分兑换";
					this.ExchangeData = Data.ExchangeData;
				}else{
					this.$router.push('/');
					location.reload();
					ElMessage.error(Message);
				}
			})
		},


	},
	mounted(){

	},
	watch:{
		onShow(Value){
			if(Value){
				this.GetInit();
			}
		},


	},
	emits:{
		"onHide":null,
	}
}

